export const firebaseErrors = {
  "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */:
    "This operation is restricted to administrators only.",
  "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */: "",
  "app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */:
    "This app, identified by the domain where it's hosted, is not " +
    "authorized to use Firebase Authentication with the provided API key. " +
    "Review your key configuration in the Google API console.",
  "app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */:
    "The requested mobile application corresponding to the identifier (" +
    "Android package name or iOS bundle ID) provided is not installed on " +
    "this device.",
  "captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */:
    "The reCAPTCHA response token provided is either invalid, expired, " +
    "already used or the domain associated with it does not match the list " +
    "of whitelisted domains.",
  "code-expired" /* AuthErrorCode.CODE_EXPIRED */:
    "The SMS code has expired. Please re-send the verification code to try " +
    "again.",
  "cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */:
    "Cordova framework is not ready.",
  "cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */:
    "This browser is not supported.",
  "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */:
    "This credential is already associated with a different user account.",
  "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */:
    "The custom token corresponds to a different audience.",
  "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */:
    "This operation is sensitive and requires recent authentication. Log in " +
    "again before retrying this request.",
  "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */:
    "Another Firebase SDK was initialized and is trying to use Auth before Auth is " +
    "initialized. Please be sure to call `initializeAuth` or `getAuth` before " +
    "starting any other Firebase SDK.",
  "dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */:
    "Please activate Dynamic Links in the Firebase Console and agree to the terms and " +
    "conditions.",
  "email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */:
    "Multi-factor users must always have a verified email.",
  "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */:
    "The email address is already in use by another account.",
  "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */:
    "Auth instance has already been used to make a network call. Auth can " +
    "no longer be configured to use the emulator. Try calling " +
    '"connectAuthEmulator()" sooner.',
  "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */:
    "The action code has expired.",
  "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */:
    "This operation has been cancelled due to another conflicting popup being opened.",
  "internal-error" /* AuthErrorCode.INTERNAL_ERROR */:
    "An internal AuthError has occurred.",
  "invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */:
    "The phone verification request contains an invalid application verifier." +
    " The reCAPTCHA token response is either invalid or expired.",
  "invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */:
    "The mobile app identifier is not registed for the current project.",
  "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */:
    "This user's credential isn't valid for this project. This can happen " +
    "if the user's token has been tampered with, or if the user isn't for " +
    "the project associated with this API key.",
  "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */:
    "An internal AuthError has occurred.",
  "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */:
    "The SMS verification code used to create the phone auth credential is " +
    "invalid. Please resend the verification code sms and be sure to use the " +
    "verification code provided by the user.",
  "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */:
    "The continue URL provided in the request is invalid.",
  "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */:
    "The following Cordova plugins must be installed to enable OAuth sign-in: " +
    "cordova-plugin-buildinfo, cordova-universal-links-plugin, " +
    "cordova-plugin-browsertab, cordova-plugin-inappbrowser and " +
    "cordova-plugin-customurlscheme.",
  "invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */:
    "The custom token format is incorrect. Please check the documentation.",
  "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */:
    "The provided dynamic link domain is not configured or authorized for the current project.",
  "invalid-email" /* AuthErrorCode.INVALID_EMAIL */:
    "The email address is badly formatted.",
  "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */:
    "Emulator URL must start with a valid scheme (http:// or https://).",
  "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */:
    "Your API key is invalid, please check you have copied it correctly.",
  "invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */:
    "The SHA-1 certificate hash provided is invalid.",
  "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */:
    "Your email address or password is incorrect.",
  "invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */:
    "The email template corresponding to this action contains invalid characters in its message. " +
    "Please fix by going to the Auth email templates section in the Firebase Console.",
  "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */:
    "The request does not contain a valid proof of first factor successful sign-in.",
  "invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */:
    "EmailAuthProvider is not supported for this operation. This operation " +
    "only supports OAuth providers.",
  "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */:
    "The OAuth client ID provided is either invalid or does not match the " +
    "specified API key.",
  "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */:
    "This domain is not authorized for OAuth operations for your Firebase " +
    "project. Edit the list of authorized domains from the Firebase console.",
  "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */:
    "The action code is invalid. This can happen if the code is malformed, " +
    "expired, or has already been used.",
  "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */:
    "The password is invalid or the user does not have a password.",
  "invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */:
    "The specified persistence type is invalid. It can only be local, session or none.",
  "invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */:
    "The format of the phone number provided is incorrect. Please enter the " +
    "phone number in a format that can be parsed into E.164 format. E.164 " +
    "phone numbers are written in the format +country codesubscriber " +
    "number including area code.",
  "invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */:
    "The specified provider ID is invalid.",
  "invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */:
    "The email corresponding to this action failed to send as the provided " +
    "recipient email address is invalid.",
  "invalid-sender" /* AuthErrorCode.INVALID_SENDER */:
    "The email template corresponding to this action contains an invalid sender email or name. " +
    "Please fix by going to the Auth email templates section in the Firebase Console.",
  "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */:
    "The verification ID used to create the phone auth credential is invalid.",
  "invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */:
    "The Auth instance's tenant ID is invalid.",
  "login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */:
    "Login blocked by user-provided method: {$originalMessage}",
  "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */:
    "An Android Package Name must be provided if the Android App is required to be installed.",
  "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */:
    "Be sure to include authDomain when calling firebase.initializeApp(), " +
    "by following the instructions in the Firebase console.",
  "missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */:
    "The phone verification request is missing an application verifier " +
    "assertion. A reCAPTCHA response token needs to be provided.",
  "missing-verification-code" /* AuthErrorCode.MISSING_CODE */:
    "The phone auth credential was created with an empty SMS verification code.",
  "missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */:
    "A continue URL must be provided in the request.",
  "missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */:
    "An internal AuthError has occurred.",
  "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */:
    "An iOS Bundle ID must be provided if an App Store ID is provided.",
  "missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */:
    "The request does not contain a valid nonce. This can occur if the " +
    "SHA-256 hash of the provided raw nonce does not match the hashed nonce " +
    "in the ID token payload.",
  "missing-password" /* AuthErrorCode.MISSING_PASSWORD */:
    "A non-empty password must be provided",
  "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */:
    "No second factor identifier is provided.",
  "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */:
    "The request is missing proof of first factor successful sign-in.",
  "missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */:
    "To send verification codes, provide a phone number for the recipient.",
  "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */:
    "The phone auth credential was created with an empty verification ID.",
  "app-deleted" /* AuthErrorCode.MODULE_DESTROYED */:
    "This instance of FirebaseApp has been deleted.",
  "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */:
    "The user does not have a second factor matching the identifier provided.",
  "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */:
    "Proof of ownership of a second factor is required to complete sign-in.",
  "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */:
    "An account already exists with the same email address but different " +
    "sign-in credentials. Sign in using a provider associated with this " +
    "email address.",
  "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */:
    "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
  "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */:
    "An internal AuthError has occurred.",
  "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */:
    "User was not linked to an account with the given provider.",
  "null-user" /* AuthErrorCode.NULL_USER */:
    "A null user object was provided as the argument for an operation which " +
    "requires a non-null user object.",
  "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */:
    "The given sign-in provider is disabled for this Firebase project. " +
    "Enable it in the Firebase console, under the sign-in method tab of the " +
    "Auth section.",
  "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */:
    "This operation is not supported in the environment this application is " +
    'running on. "location.protocol" must be http, https or chrome-extension' +
    " and web storage must be enabled.",
  "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */:
    "Unable to establish a connection with the popup. It may have been blocked by the browser.",
  "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */:
    "The popup has been closed by the user before finalizing the operation.",
  "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */:
    "User can only be linked to one identity for the given provider.",
  "quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */:
    "The project's quota for this operation has been exceeded.",
  "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */:
    "The redirect operation has been cancelled by the user before finalizing.",
  "redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */:
    "A redirect sign-in operation is already pending.",
  "rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */:
    "The request contains malformed or mismatching credentials.",
  "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */:
    "The second factor is already enrolled on this account.",
  "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */:
    "The maximum allowed number of second factors on a user has been exceeded.",
  "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */:
    "The provided tenant ID does not match the Auth instance's tenant ID",
  timeout /* AuthErrorCode.TIMEOUT */: "The operation has timed out.",
  "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */:
    "The user's credential is no longer valid. The user must sign in again.",
  "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */:
    "We have blocked all requests from this device due to unusual activity. " +
    "Try again later.",
  "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */:
    "The domain of the continue URL is not whitelisted.  Please whitelist " +
    "the domain in the Firebase console.",
  "unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */:
    "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
  "unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */:
    "The current environment does not support the specified persistence type.",
  "unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */:
    "This operation is not supported in a multi-tenant context.",
  "unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */:
    "The operation requires a verified email.",
  "user-cancelled" /* AuthErrorCode.USER_CANCELLED */:
    "The user did not grant your application the permissions it requested.",
  "user-not-found" /* AuthErrorCode.USER_DELETED */:
    "There is no user record corresponding to this identifier. The user may " +
    "have been deleted.",
  "user-disabled" /* AuthErrorCode.USER_DISABLED */:
    "The user account has been disabled by an administrator.",
  "user-mismatch" /* AuthErrorCode.USER_MISMATCH */:
    "The supplied credentials do not correspond to the previously signed in user.",
  "user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */: "",
  "weak-password" /* AuthErrorCode.WEAK_PASSWORD */:
    "The password must be 12 characters long or more.",
  "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */:
    "This browser is not supported or 3rd party cookies and data may be disabled.",
  "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */:
    "initializeAuth() has already been called with " +
    "different options. To avoid this error, call initializeAuth() with the " +
    "same options as when it was originally called, or call getAuth() to return the" +
    " already initialized instance.",
  "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */:
    "The reCAPTCHA token is missing when sending request to the backend.",
  "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */:
    "The reCAPTCHA token is invalid when sending request to the backend.",
  "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */:
    "The reCAPTCHA action is invalid when sending request to the backend.",
  "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */:
    "reCAPTCHA Enterprise integration is not enabled for this project.",
  "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */:
    "The reCAPTCHA client type is missing when sending request to the backend.",
  "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */:
    "The reCAPTCHA version is missing when sending request to the backend.",
  "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */:
    "Invalid request parameters.",
  "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */:
    "The reCAPTCHA version is invalid when sending request to the backend.",
  "unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */:
    "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
  "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */:
    "Password must be at least 12 characters long and include an uppercase letter, a lowercase letter, and a number.",
};
